import React from "react";

export function DribbbleOutlined({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4C6.25048 4 4 6.25048 4 9V41C4 43.7495 6.25048 46 9 46H41C43.7495 46 46 43.7495 46 41V9C46 6.25048 43.7495 4 41 4H9ZM9 6H41C42.6685 6 44 7.33152 44 9V41C44 42.6685 42.6685 44 41 44H9C7.33152 44 6 42.6685 6 41V9C6 7.33152 7.33152 6 9 6ZM26.1738 11C22.0398 11 22 21.271 22 21.375C22 22.583 21.9991 23.375 22.0801 24.375C21.5111 24.178 20.85 24.0527 20.127 24.0527C15.881 24.0527 14 28.3769 14 32.0469C14 35.5079 16.0554 39 20.6504 39C22.8174 39 24.65 37.6592 26.123 35.6582C27.429 36.9382 28.7963 36.9805 29.8203 36.9805C33.0363 36.9805 35.1656 31.1778 35.9316 28.8438C36.1756 28.0968 35.7438 27.3005 34.9648 27.0645C34.1928 26.8325 33.3553 27.2432 33.1113 27.9902C32.2063 30.7462 31.254 33.28 29.75 34C29.225 34.251 28.418 33.924 27.625 32.875C29.468 29.148 30 24.621 30 21.5C30 12.774 28.1358 11 26.1738 11ZM26.291 14.0469C26.757 14.7119 27.0449 16.736 27.0449 21.498C27.0439 24.026 26.9242 27.0188 25.9902 29.5918C25.3742 27.5908 24.957 24.892 24.957 21.373C24.957 18.129 25.682 15.0879 26.291 14.0469ZM20.125 27C21.384 27 22.3496 27.8085 22.3496 27.8105C22.4216 27.8825 22.5 27.945 22.582 28C22.995 29.973 23.6307 31.9267 24.3027 33.1777C23.2007 34.9797 21.896 36 20.625 36C17.29 36 17 33.362 17 32.125C17 31.93 16.939 27 20.125 27Z"
        fill="currentColor"
      />
    </svg>
  );
}
